'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _esSymbol = require('es-symbol');

var _esSymbol2 = _interopRequireDefault(_esSymbol);

// action creator handler
var ACTION_HANDLER = (0, _esSymbol2['default'])();

exports.ACTION_HANDLER = ACTION_HANDLER;
// the action's uid symbol for listening
var ACTION_KEY = (0, _esSymbol2['default'])();

exports.ACTION_KEY = ACTION_KEY;
// per instance registry of actions
var ACTIONS_REGISTRY = (0, _esSymbol2['default'])();

exports.ACTIONS_REGISTRY = ACTIONS_REGISTRY;
// the action's name
var ACTION_UID = (0, _esSymbol2['default'])();

exports.ACTION_UID = ACTION_UID;
// store all of a store's listeners
var ALL_LISTENERS = (0, _esSymbol2['default'])();

exports.ALL_LISTENERS = ALL_LISTENERS;
// are we handling our own errors
var HANDLING_ERRORS = (0, _esSymbol2['default'])();

exports.HANDLING_ERRORS = HANDLING_ERRORS;
// initial snapshot
var INIT_SNAPSHOT = (0, _esSymbol2['default'])();

exports.INIT_SNAPSHOT = INIT_SNAPSHOT;
// last snapshot
var LAST_SNAPSHOT = (0, _esSymbol2['default'])();

exports.LAST_SNAPSHOT = LAST_SNAPSHOT;
// all lifecycle listeners
var LIFECYCLE = (0, _esSymbol2['default'])();

exports.LIFECYCLE = LIFECYCLE;
// store action listeners
var LISTENERS = (0, _esSymbol2['default'])();

exports.LISTENERS = LISTENERS;
// public methods
var PUBLIC_METHODS = (0, _esSymbol2['default'])();

exports.PUBLIC_METHODS = PUBLIC_METHODS;
// contains all state
var STATE_CONTAINER = (0, _esSymbol2['default'])();
exports.STATE_CONTAINER = STATE_CONTAINER;


//////////////////
// WEBPACK FOOTER
// ./~/@jimpick/spectacle/~/alt/lib/symbols/symbols.js
// module id = 121
// module chunks = 2